import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';
import { useState, useEffect } from 'react';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('https://public.readdy.ai/ai/img_res/196e444d027bfa749b7147598da54d48.jpg')"
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-center">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          PackDeRopa.com
        </h1>
        <p className="text-2xl md:text-3xl text-white/95 mb-4 font-medium">
          Pack de Ropa al Por Mayor con Envío Gratuito
        </p>
        <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-4xl mx-auto">
          Camisetas desde 2.45€ · Polos · Chaquetas · Sudaderas · Chalecos
        </p>
        
        {/* Offer Banner */}
        <div className="inline-block bg-teal-500 text-white px-8 py-4 rounded-lg mb-8 shadow-lg">
          <p className="text-lg font-semibold">
            🔥 Ofertas Especiales desde el 1 de Febrero 2025
          </p>
          <p className="text-sm mt-1">
            Chaquetas Antártida: Unidad 35€ · Pack 10 unidades 295€
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a 
            href="/packages" 
            className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Ver Packs Especiales
          </a>
          <a 
            href="/catalog" 
            className="bg-white hover:bg-gray-100 text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Ver Catálogo Completo
          </a>
        </div>

        {/* Key Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-lg">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
              <i className="ri-truck-line text-3xl text-teal-500"></i>
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Envío Gratuito</h3>
            <p className="text-sm text-gray-600">En todos los packs</p>
          </div>
          
          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-lg">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
              <i className="ri-price-tag-3-line text-3xl text-teal-500"></i>
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Precios Mayorista</h3>
            <p className="text-sm text-gray-600">Mínimo 10 unidades</p>
          </div>
          
          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-lg">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
              <i className="ri-shield-check-line text-3xl text-teal-500"></i>
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Calidad Garantizada</h3>
            <p className="text-sm text-gray-600">Marcas Roly y Valento</p>
          </div>
        </div>
      </div>
    </section>
  );
}